<template>
  <div class="base case">
    <div class="top-area">
      <div class="top">
        <div class="back-index" @click="goIndex">
          <span>返回首页</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="info">
        <div class="madel">
          <div class="promote-title-img" />
        </div>
        <div class="promote-item">
          <div class="title title-one">
            <span>分享推广码</span>
          </div>
          <div class="desc">
            分享推广码给用户，用户在注册时填写推广码即为您的推广用户，注册成功后实名认证后即可获得现金红包
          </div>
        </div>
        <div class="promote-item">
          <div class="title title-two">
            <span>分享推广链接</span>
          </div>
          <div class="desc">
            分享推广链接给用户，用户通过推广链接注册即为您的推广用户，注册成功后实名认证后即可获得现金红包
          </div>
        </div>
      </div>
      <div class="over">
        <span>
          *&nbsp;&nbsp;&nbsp;&nbsp;推广用户必须为实名认证用户，并填写申请为推广大使，成为推广大使后系统会自动生成推广码与推广链接
        </span>
      </div>
      <!-- 推广规则 -->
      <div class="rule-area">
        <div class="rule-title">
          <span>推广规则</span>
        </div>
        <div class="list">
          <ul>
            <li>
              推荐大使需要先注册（教员和用户身份皆可）实名认证后提交申请成为推广大使获取推广码
            </li>
            <li>
              推荐用户注册小橙家教平台，用户实名认证后，推荐人可得2元佣金，用户符合教员申请规则并成功认证为教员，推荐人可再获得8元佣金。佣金满10元即可提现
            </li>
            <li>同一手机，同一身份信息视为同一人，注册两种身份只有一份佣金</li>
            <li>本推荐不使用于被推荐者非首次注册、推荐自己</li>
          </ul>
          <div class="other">
            <p style="padding: 0 15px; color: #fff">
              任何问题，请邮件联系：admin@orangmust.com
            </p>
            <p style="padding: 0 15px; color: #fee1d0">
              本活动的最终解释权归广安小橙科技所有
            </p>
          </div>
        </div>
      </div>
      <div class="apply-area admit" style="">
        <div class="apply" />
        <!-- 未登录 -->
        <div v-if="!login_status" class="nend-login">
          <div>
            <img
              src="@/assets/promote/no-login.png"
              width="200px"
              style="margin-top: 20px"
              alt=""
            />
          </div>
          <div style="font-size: 22px; color: #ff5c00; margin-top: 30px">
            您还没有登录
          </div>
          <div style="font-size: 16px; color: #2c3e50; margin-top: 5px">
            请先登录或注册后再提交申请为推广者
          </div>
          <div>
            <a-button
              type="primary"
              size="large"
              style="width: 300px; margin-top: 40px"
              @click="goLogin"
            >
              去登录
            </a-button>
          </div>
        </div>
        <div v-else-if="login_status && !promoter_status">
          <a-row :gutter="8" class="item name">
            <a-col :span="8" class="label-title" align="right"> 姓名： </a-col>
            <a-col :span="14" align="left">
              <div v-if="realname_status">
                {{ true_name }}
              </div>
              <div v-else>
                <a-button type="link" @click="goRealname">
                  需要先实名认证
                </a-button>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="8" class="item phone">
            <a-col :span="8" class="label-title" align="right">
              手机号：
            </a-col>
            <a-col :span="14" align="left">
              {{ phone }}
            </a-col>
          </a-row>
          <a-row :gutter="8" class="item apply-reason">
            <a-col :span="8" class="label-title" align="right">
              推广原因：
            </a-col>
            <a-col :span="14">
              <a-textarea
                v-model="reason"
                :rows="4"
                style="resize: none"
                placeholder="请简述您成为推广大使的原因"
              />
            </a-col>
          </a-row>
          <a-row v-if="realname_status" :gutter="8" class="apply-submit-area">
            <a-col :span="8" />
            <a-col :span="8">
              <a-button
                type="primary"
                size="large"
                :loading="state.applyBtn"
                @click="applySubmit"
              >
                提交申请
              </a-button>
            </a-col>
          </a-row>
        </div>
        <div v-else>
          <div style="font-size: 24px">您已成为推广大使</div>
          <div style="margin-top: 20px">
            <a-button
              type="primary"
              size="large"
              block
              @click="goPromotionPage"
            >
              前往推广中心
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-area">
      <span>©2020-2026小橙家教</span>
      <span style="margin-left: 10px">蜀ICP备2020035072号</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PromotePage',
  data() {
    return {
      loading: true,
      state: {
        applyBtn: false
      },
      login_status: false,
      auth_user_type: '',
      realname_status: false,
      true_name: '',
      promote_enable: true,
      promoter_status: false,
      // config
      promote_name: '',
      promote_desc: '',
      promote_amount: '',
      promote_register_commission: 0,
      promote_realname_commission: 2,
      promote_apply_teacher_commission: 8,
      phone: '',
      // 原因
      reason: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: '/index/index/promote',
        method: 'get',
        params: {}
      }).then((res) => {
        this.loading = false
        if (res.status === 'success') {
          console.log(res)
          const data = res.data
          this.auth_user_type = data.auth_user_type
          this.login_status = data.login_status
          this.promote_enable = data.promote_enable
          this.realname_status = data.realname_status
          this.true_name = data.true_name
          this.promoter_status = data.promoter_status
          this.phone = data.phone
          const config = data.config
          this.promote_amount = config.promote_amount
          this.promote_name = config.promote_name
          this.promote_desc = config.promote_desc
          this.promote_apply_teacher_commission =
            config.promote_apply_teacher_commission
          this.promote_realname_commission = config.promote_realname_commission
          this.promote_register_commission = config.promote_register_commission
        } else {
          this.$notification.error({
            message: '错误',
            description: '获取数据错误'
          })
        }
      })
    },
    applySubmit() {
      if (this.reason === '') {
        this.$toast.fail('请输入推广原因')
        return false
      }
      this.state.applyBtn = true
      this.$http({
        url: '/index/promote/apply',
        method: 'post',
        data: {
          reason: this.reason
        }
      }).then((res) => {
        this.state.applyBtn = false
        if (res.status === 'success') {
          this.$notification.success({
            message: '成功',
            description: '申请提交成功'
          })
          this.visibleApplyDrawer = false
          this.loadData()
        } else {
          this.$notification.error({
            message: '错误',
            description: res.message
          })
        }
      })
    },
    goPromotionPage() {
      // 是否登录
      if (this.login_status) {
        if (this.auth_user_type === 'user') {
          this.$router.push({ name: 'UserPromotion' })
        } else {
          this.$router.push({ name: 'TeacherPromotion' })
        }
      } else {
        this.$router.push({ name: 'UserLogin' })
      }
    },
    goRealname() {
      if (this.login_status) {
        if (this.auth_user_type === 'user') {
          this.$router.push({ name: 'UserSettingRealname' })
        } else {
          this.$router.push({ name: 'TeacherSettingRealname' })
        }
      } else {
        this.$router.push({ name: 'UserLogin' })
      }
    },
    goLogin() {
      this.$router.push({ name: 'UserLogin' })
    },
    goIndex() {
      this.$router.push({ name: 'Index' })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .case {
      .top-area {
        width:100%;
        height:203px;
        background: url('~@/assets/promote/promote@2x.png') no-repeat;
        background-size: cover;
        padding:0 10px;

        .top {
            padding-top: 10px;
            .back-index {
                width:90px;
                padding: 5px;
                text-align: center;
                // 背景颜色div透明，而其中的汉字不透明
                background:rgba(255, 255, 255, 0.2);
                border-radius:15px;
                span {
                    position:relative;
                    color: #fff;
                }
            }
        }
      }

    .witch {
        margin-top:22px;
        text-align:center;
        span{
            font-family:BDZYJT--GB1-0;
            font-size:36px;
            color:#ffffff;
            letter-spacing:4px;
        }
    }
    .wape {
        margin-top:13px;
        font-size:12px;
        text-align:center;
        color:#ffe0ce;
    }

    .content {
        background-image: linear-gradient(#ff5e03, #fc6814);
        padding: 0 15px;
        padding-bottom: 30px;
    }
    .info {
        padding:40px 10px;
        background-color:#ffffff;
        border-radius:25px;
        // 内发光
        box-shadow:#ffe8bc 0px 0px 18px inset;

        .madel{
            text-align:center;

            .promote-title-img {
                margin: auto;
                width: 93px;
                height: 21px;
                background: url('~@/assets/promote/标题@2x.png') no-repeat;
                background-size: cover;
                // background-size: 93px 21px;
            }
        }

        .promote-item {
            margin-top: 20px;
            .title {
                height: 40px;
                text-align: center;
                line-height: 40px;

                span {
                    margin-left: 20px;
                    font-family: PingFang-SC-Medium;
                    font-size: 16px;
                    line-height: 40px;
                    letter-spacing: 2px;
                    color: #ff5c00;
                }
            }

            .title-one {
                width: 155px;
                background: url('~@/assets/promote/01@2x.png') no-repeat;
                background-size: cover;
            }

            .title-two {
                width: 170px;
                background: url('~@/assets/promote/02@2x.png') no-repeat;
                background-size: cover;
            }

            .desc {
                font-family: PingFang-SC-Medium;
                font-size: 14px;
                line-height: 24px;
                letter-spacing: 2px;
                color: #000;
            }
        }
    }
    .over{
        padding:30px 15px;
        span {
            font-family: PingFang-SC-Regular;
            font-size: 14px;
            line-height: 30px;
            letter-spacing: 2px;
            color: #fef6e5;
        }
    }

    .rule-area {
        margin-top: 10px;
        .rule-title {
            padding: 5px 10px;
            span {
                font-family: PingFang-SC-Bold;
                font-size: 18px;
                line-height: 14px;
                letter-spacing: 0px;
                color: #ffffff;
            }
        }
        .list {
            border:1px dashed #ffb58b;
            border-radius:25px;
            ul{
                display: block;
                list-style-type: disc;
                padding-inline-start: 30px;
                margin-top:31px;
                font-family:PingFang-SC-Medium;
                font-size:14px;
                line-height:25px;
                color: #fff;
            }
        }
    }
    .admit{
        position: relative;
        top: 60px;
        padding:0px 15px 30px 15px;
        // margin-top: 67px;
        box-shadow: 1px 3px 16px 0px rgba(34, 23, 20, 0.1);
        border-radius: 25px;
        background-color:#ffffff;
        .apply{
            width:178px;
            height:50px;
            background: url('~@/assets/promote/申请为推广者@2x.png') no-repeat;
            background-size: cover;
            margin: auto;
            position: relative;
            top: -20px;
        }
    }

    .apply-area {
        .nend-login {
            text-align: center;
        }

        .title {
            font-family: PingFang-SC-Medium;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 79px;
            letter-spacing: 3px;
            color: $theme-color;
        }

        .item {
            margin-top: 20px;

            .label-title {
            font-size: 16px;
            }
        }

        .name, .phone {
            height: 40px;
            line-height: 40px;
        }

        .apply-submit-area {
            margin-top: 20px;
        }
    }

    .footer-area{
        height: 150px;
        background: url('~@/assets/promote/Leafbackground08@2x.png') no-repeat;
        background-size: cover;
        text-align:center;

        span {
            font-family: PingFang-SC-Regular;
            font-size: 11px;
            line-height: 150px;
            color:#ffffff;
        }
    }
}
</style>
